module.exports = __webpack_public_path__ + "img/ico-eye.bc8b972f.svg";